var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectionBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6591 23H16.3516C19.912 23 22.6433 21.7325 21.8675 16.6309L20.9641 9.71704C20.4859 7.17149 18.8385 6.19727 17.3932 6.19727H5.57507C4.10843 6.19727 2.55678 7.24482 2.00413 9.71704L1.10077 16.6309C0.441848 21.1563 3.09879 23 6.6591 23Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49952 5.94449C6.49952 3.21375 8.7454 1.00004 11.5158 1.00004V1.00004C12.8499 0.994472 14.1313 1.51294 15.0767 2.44081C16.022 3.36868 16.5534 4.62951 16.5534 5.94449V5.94449",
    stroke: "#9E9E9E",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07253 11.099H8.12567",
    stroke: "#9E9E9E",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8425 11.099H14.8956",
    stroke: "#9E9E9E",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionBag);
export default __webpack_public_path__ + "static/media/CollectionBag.1c53713f6428d0883e67888189a96fe0.svg";
export { ForwardRef as ReactComponent };